import axios from "axios";
import Auth from "../common/Auth";
function them(hopDong) {
    return axios.post(process.env.REACT_APP_URL_SERVER + "/cus/hopdong/them", hopDong);
};
function getAll() {
    return axios.get(process.env.REACT_APP_URL_SERVER + "/cus/hopdong/getall");
};
function timHopDongTheoMa(maHD) {
    return axios.get(process.env.REACT_APP_URL_SERVER + "/cus/hopdong/getbymahd?maHD=" + maHD);
};
function capNhat(hopDong) {
    return axios.post(process.env.REACT_APP_URL_SERVER + "/cus/hopdong/capnhat", hopDong);
};
function xoa(ids) {
    return axios.post(process.env.REACT_APP_URL_SERVER + "/cus/hopdong/xoa", ids);
};
function xuLyHetHan(hopDong) {
    return axios.post(process.env.REACT_APP_URL_SERVER + "/cus/hopdong/xulyhethan", hopDong);
};
function importFile(file) {
    return axios.post(process.env.REACT_APP_URL_SERVER + "/cus/hopdong/import", file);
};
function saveImportFile(listKH) {
    return axios.post(process.env.REACT_APP_URL_SERVER + "/cus/hopdong/savelist", listKH);
};
function getUrlPage(listQuyen, roleUser) {
    if (Auth.checkUrl("/cus/hopdong/getall", listQuyen, roleUser)) {
        return process.env.REACT_APP_URL_SERVER + "/cus/hopdong/getpage";
    }
    else return process.env.REACT_APP_URL_SERVER + "/cus/personal/hopdong/getpage";


};
function getUrlSearch(key, listQuyen, roleUser) {
    if (Auth.checkUrl("/cus/hopdong/getall", listQuyen, roleUser)) {
        return process.env.REACT_APP_URL_SERVER + "/cus/hopdong/search?key=" + key;
    } else return process.env.REACT_APP_URL_SERVER + "/cus/personal/hopdong/search?key=" + key;

};
function getUrlFilterStatus(listQuyen, roleUser) {
    if (Auth.checkUrl("/cus/hopdong/getall", listQuyen, roleUser)) {
        return process.env.REACT_APP_URL_SERVER + "/cus/hopdong/fillter";
    } else return process.env.REACT_APP_URL_SERVER + "/cus/personal/hopdong/fillter";

};
const HopDongService = {
    them,
    saveImportFile,
    getAll,
    timHopDongTheoMa,
    capNhat,
    xoa,
    xuLyHetHan,
    importFile,
    getUrlPage,
    getUrlSearch,
    getUrlFilterStatus
};
export default HopDongService;
